import serviceimg from '../assets/images/about_img.png';
import VisionMission from './VisionMission';
import PageHeader from '@/components/PageHeader';

function About() {
  return (
    <div className="font-sans ">

      <PageHeader title='About Us' imageUrl={serviceimg} breadcrumbs={['Home', 'About Us']} />
      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="w-full md:w-4/5 lg:w-3/5">

          <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            About FDAc
          </h2>

          <p className="mb-4 text-[#05326D] mt-12">
            Your Strategic Partner in Global Regulatory, Clinical, Quality & Safety Solutions
          </p>
          <p className="mb-4 text-[#05326D]">
            At FDAc Consultancy, we deliver a full spectrum of tailored services across regulatory affairs, clinical research, quality assurance, and pharmacovigilance—serving pharmaceutical, medical device, cosmetics, and nutraceutical companies worldwide.
          </p>
          <p className="mb-4 text-[#05326D] mb-12">
            With deep expertise and a client-centric approach, we support organizations in navigating complex regulatory landscapes, accelerating product approvals, and achieving sustainable growth across India and global markets.
          </p>

          <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            Why Choose FDAc?
          </h2>

          <h4 className="text-sm font-bold text-[#05326D] mb-2">True Partnership</h4>
          <p className="mb-4 text-[#05326D]">
            We view every engagement as a collaborative journey. Your success is our success. Our proven track record and data-driven insights empower life science leaders to make confident, informed decisions.
          </p>

          <h4 className="text-sm font-bold text-[#05326D] mb-2">Customized Strategies</h4>
          <p className="mb-4 text-[#05326D]">
            No two companies are alike. We assess your specific regulatory needs and deliver bespoke solutions that align with your business goals, timelines, and compliance requirements.
          </p>

          <h4 className="text-sm font-bold text-[#05326D] mb-2">Global Reach</h4>
          <p className="mb-12 text-[#05326D]">
            With decades of experience and a high approval rate, we’ve helped clients secure registrations in the US, Latin America, Europe, Asia, and beyond—across drug products, medical devices, cosmetics, and nutraceuticals.
          </p>

          <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            Benefits of Working with FDAc
          </h2>
          
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            We operate with the same passion and precision as our clients
          </div>
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            We simplify complex regulatory pathways and accelerate market access
          </div>
          <div className="flex items-center gap-2 mb-12 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            We manage your regulatory, clinical, quality, and safety functions—so you can focus on innovation and growth
          </div>

          <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
            <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
            With FDAc, You Can
          </h2>

          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            Tap into a broad base of international regulatory expertise
          </div>
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            Minimize compliance risks and avoid costly delays
          </div>
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            Expedite approvals and optimize submission timelines
          </div>
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            Achieve strategic expansion with confidence and clarity
          </div>
          <div className="flex items-center gap-2 mb-2 text-[#05326D]">
            <div className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></div>
            FDAc is more than a consultancy—we’re your trusted partner in transforming regulatory challenges into global opportunities.
          </div>
        </div>
      </div>


      <div className="max-w-6xl mx-auto px-6 mt-12">
        <VisionMission />
      </div>
    </div>
  );
}

export default About;



